import React from 'react';
import { SectionLabel } from './ui/SectionLabel';
import { InteriorCarousel } from './InteriorCarousel';
const labels = ['Class Intention', 'Main Sequence', 'Teaching Cues', 'Transitions', 'Modifications', 'Closing'];
export function InsideSystemSection() {
  return <section className="w-full bg-sand py-10 sm:py-14 lg:py-20" aria-labelledby="inside-heading" data-id="element-81" data-mp="3r8pg5cerg4wo">
      <div className="mx-auto w-full max-w-content px-5 sm:px-8" data-id="element-82" data-mp="sqjx3v9f6f1h">
        <div className="mx-auto max-w-2xl text-center" data-id="element-83" data-mp="soqzf5gsb55m">
          <div className="flex justify-center" data-id="element-84" data-mp="nrgyask1951y">
            <SectionLabel data-id="element-85" data-mp="npnwproa1b0t">Inside the system</SectionLabel>
          </div>
          <h2 id="inside-heading" className="mt-3 font-serif text-[1.6rem] font-semibold uppercase leading-[1.08] text-ink sm:text-4xl" data-id="element-86" data-mp="ir2qnbmcfx4g">
            Take a look <span className="text-forest" data-id="element-87" data-mp="33jxy3duvx2xm">inside</span>
          </h2>
          <p className="mx-auto mt-3 max-w-lg text-[0.9rem] leading-snug text-muted sm:text-lg" data-id="element-88" data-mp="2yk1tbced57h0">
            See the actual class structures, teaching guidance and professional resources included
            inside Yoga Teacher System™.
          </p>
        </div>

        <InteriorCarousel data-id="element-89" data-mp="20fd8u35i71ce" />

        <p className="mt-5 text-center font-serif text-[1rem] font-semibold uppercase leading-tight text-ink sm:text-xl" data-id="element-90" data-mp="1lkffb6ymc5tq">
          Real pages. Complete classes. Ready to teach.
        </p>

        <ul className="mt-4 grid grid-cols-2 gap-2 sm:grid-cols-3" data-id="element-91" data-mp="1crvfi36lbv7b">
          {labels.map(label => <li key={label} className="rounded-xl border border-sandDark bg-ivory px-3 py-2.5 text-center text-[0.65rem] font-semibold uppercase leading-tight tracking-label text-ink sm:text-[0.7rem]" data-id="element-92" data-mp="1hibsxnaevgto">
              {label}
            </li>)}
        </ul>
      </div>
    </section>;
}